import { SeekerVerticalType } from '@/types/seeker';
import { AppState } from '@/types/app';
import { EnrollmentServiceType } from '@/types/common';
import { SessionStorageHelper } from './SessionStorageHelper';
import {
  FLOWS,
  LOCAL_STORAGE_STATE_KEY,
  serviceTypeMapping,
  SHORT_ENROLLMENT_ROUTES,
  VERTICALS_NAMES,
} from '../constants';

// verticals markers
const childCareMarker = new RegExp(FLOWS.SEEKER_CHILD_CARE.path);
export const childCareDaycareMarker = new RegExp(FLOWS.SEEKER_DAYCARE_CHILD_CARE.path);
const childCareProviderMarker = new RegExp(FLOWS.CHILD_CARE_PROVIDER.path);
const childCareCampsMarker = new RegExp(FLOWS.SEEKER_CAMPS_ACTIVITIES_CARE_KIND.path);
const housekeepingMarker = new RegExp(FLOWS.SEEKER_HOUSEKEEPING.path);
const petCareMarker = new RegExp(FLOWS.SEEKER_PET_CARE.path);
const tutoringMarker = new RegExp(FLOWS.SEEKER_TUTORING.path);
const shortEnrollmentMarker = new RegExp(SHORT_ENROLLMENT_ROUTES.INDEX);
const multiVerticalEnrollmentMarker = new RegExp(FLOWS.PROVIDER_MULTI_VERTICAL.path);
const scProviderEnrollmentMarker = new RegExp(FLOWS.PROVIDER.path);
const scSeekerEnrollmentMarker = new RegExp(FLOWS.SEEKER_SENIOR_CARE_V2.path);
const ltcgEnrollmentMarker = new RegExp(FLOWS.LTCG.path);
const scPostAJobFlow =
  /\/app\/enrollment\/(post-a-job|recurring|onetime|pay-for-care|about-loved-one|ideal-caregiver|caregivers-near-you)/;

const getVerticalFromState = (path?: string): SeekerVerticalType => {
  try {
    const stateFromStorageJson = SessionStorageHelper.getItem(LOCAL_STORAGE_STATE_KEY);
    if (stateFromStorageJson) {
      const stateFromStorage = JSON.parse(stateFromStorageJson) as AppState;
      if (stateFromStorage?.seeker?.vertical) {
        return stateFromStorage.seeker.vertical;
      }
      if (
        stateFromStorage?.providerMV?.serviceType &&
        path &&
        multiVerticalEnrollmentMarker.test(path)
      ) {
        return VERTICALS_NAMES[
          serviceTypeMapping[stateFromStorage?.providerMV?.serviceType] as EnrollmentServiceType
        ];
      }
    }
  } catch (_e) {
    return null;
  }
  return null;
};

function getVertical(path?: string): string | null {
  if (!path) {
    // check vertical through URL check
    // eslint-disable-next-line no-param-reassign
    path = window.location.pathname;
  }

  // Childcare check up
  if (
    childCareMarker.test(path) ||
    childCareDaycareMarker.test(path) ||
    childCareProviderMarker.test(path) ||
    childCareCampsMarker.test(path)
  ) {
    return VERTICALS_NAMES.CHILD_CARE;
  }

  // Housekeeping check up
  if (housekeepingMarker.test(path)) {
    return VERTICALS_NAMES.HOUSEKEEPING;
  }

  // Petcare check up
  if (petCareMarker.test(path)) {
    return VERTICALS_NAMES.PET_CARE;
  }

  // Tutoring check up
  if (tutoringMarker.test(path)) {
    return VERTICALS_NAMES.TUTORING;
  }

  // Enrollment Form check up
  if (shortEnrollmentMarker.test(path)) {
    return getVerticalFromState() ?? '';
  }

  if (multiVerticalEnrollmentMarker.test(path)) {
    return getVerticalFromState(path) ?? '';
  }

  // Senior care
  if (
    scProviderEnrollmentMarker.test(path) ||
    scSeekerEnrollmentMarker.test(path) ||
    ltcgEnrollmentMarker.test(path) ||
    scPostAJobFlow.test(path)
  ) {
    return VERTICALS_NAMES.SENIOR_CARE;
  }

  // default value - null
  return null;
}

export default getVertical;
